import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { WebSocketSessionzi1ianvyj32u as WebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketSession.mjs';
import { DefaultWebSocketSession3h8506yqzs5fx as DefaultWebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/DefaultWebSocketSession.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultClientWebSocketSessionClass;
function DefaultClientWebSocketSession() {
  if (DefaultClientWebSocketSessionClass === VOID) {
    class $ {
      constructor(call, delegate) {
        this.x5w_1 = delegate;
        this.y5w_1 = call;
      }
      *h5b(frame, $completion) {
        yield* this.x5w_1.h5b(frame, $completion);
        return Unit_instance;
      }
      *u4j($completion) {
        yield* this.x5w_1.u4j($completion);
        return Unit_instance;
      }
      d5b(_set____db54di) {
        this.x5w_1.d5b(_set____db54di);
      }
      e5b() {
        return this.x5w_1.e5b();
      }
      f5b() {
        return this.x5w_1.f5b();
      }
      g5b() {
        return this.x5w_1.g5b();
      }
      sv() {
        return this.x5w_1.sv();
      }
      c5b(negotiatedExtensions) {
        this.x5w_1.c5b(negotiatedExtensions);
      }
      b5b() {
        return this.x5w_1.b5b();
      }
    }
    initMetadataForClass($, 'DefaultClientWebSocketSession', VOID, VOID, [WebSocketSession(), DefaultWebSocketSession()], [1, 0]);
    DefaultClientWebSocketSessionClass = $;
  }
  return DefaultClientWebSocketSessionClass;
}
var DelegatingClientWebSocketSessionClass;
function DelegatingClientWebSocketSession() {
  if (DelegatingClientWebSocketSessionClass === VOID) {
    class $ {
      constructor(call, session) {
        this.z5w_1 = session;
        this.a5x_1 = call;
      }
      *h5b(frame, $completion) {
        yield* this.z5w_1.h5b(frame, $completion);
        return Unit_instance;
      }
      *u4j($completion) {
        yield* this.z5w_1.u4j($completion);
        return Unit_instance;
      }
      d5b(_set____db54di) {
        this.z5w_1.d5b(_set____db54di);
      }
      e5b() {
        return this.z5w_1.e5b();
      }
      f5b() {
        return this.z5w_1.f5b();
      }
      g5b() {
        return this.z5w_1.g5b();
      }
      sv() {
        return this.z5w_1.sv();
      }
    }
    initMetadataForClass($, 'DelegatingClientWebSocketSession', VOID, VOID, [WebSocketSession()], [1, 0]);
    DelegatingClientWebSocketSessionClass = $;
  }
  return DelegatingClientWebSocketSessionClass;
}
//region block: exports
export {
  DefaultClientWebSocketSession as DefaultClientWebSocketSession1n8ok3lng45wy,
  DelegatingClientWebSocketSession as DelegatingClientWebSocketSessiono1sywc6weckz,
};
//endregion

//# sourceMappingURL=ClientSessions.mjs.map
